
//export const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY
export const CAPTCHA_KEY = "6Lc7Cx4qAAAAANWcamzHOCN8esigNuH2A2dFP5l-"


//api_key=AIzaSyArnIahKojYpOUVwSv07eNpfuTR_x-GaDY
//des V2: SITE:6LfzGBgqAAAAADuDEXuMce_P7807QE0HwNVKkafE SECRETA: 6LfzGBgqAAAAACJhHA98Lrs-VMtS9F6nMtKaHA_l
//hom v2: site: 6LerFhgqAAAAAJ617bru1sl_qVygqyGIbyfR9vev secreta:6LerFhgqAAAAAJJswSi4sG85mb5001Mh1WIsjRG8
//prod V2: site: 6LffGBgqAAAAANYcQOFcxmxWmcC0a5Viyqmxfs7a secreta: 6LffGBgqAAAAAOGO8hMkfdwqMfJMHPwaaN0I4VCF
//Nova chave pra produçao e hom - chave sitet: 6Lc7Cx4qAAAAANWcamzHOCN8esigNuH2A2dFP5l- chave secretat: 6Lc7Cx4qAAAAAFhPmAZZ7hhaPdZhiy0HRcMY_dJB